import { render, staticRenderFns } from "./CategoryAdView.vue?vue&type=template&id=0d225e7f"
import script from "./CategoryAdView.vue?vue&type=script&lang=js"
export * from "./CategoryAdView.vue?vue&type=script&lang=js"
import style0 from "./CategoryAdView.vue?vue&type=style&index=0&id=0d225e7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports